import React from 'react';
import TextInput from '../modules/common/TextInput';
import Button from '../modules/common/Button';
import default_plus_img from '../../resources/img/default_plus.svg';
import default_minus_img from '../../resources/img/default_minus.svg';

export default class ProductKeywordInputList extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        keywordList: props.initialKeywordList && props.initialKeywordList.length > 0 ? [...props.initialKeywordList] : [],
        org_keyword_list : props.org_keyword_list || [],
      };
    }
  
    componentDidUpdate(prevProps) {
      if (prevProps.initialKeywordList !== this.props.initialKeywordList) {
        this.setState({
          keywordList: this.props.initialKeywordList && this.props.initialKeywordList.length > 0 ? [...this.props.initialKeywordList] : []
        });
      }
    }
  
    handleChangeKeyword = (e, idx) => {
      const newList = [...this.state.keywordList];
      newList[idx] = e.target.value;
      this.setState({ keywordList: newList }, () => {
        this.notifyParent();
      });
    };
  
    handleAddKeyword = (keyword) => {
      this.setState(prev => {
        const keywordList = [...prev.keywordList];
      
        if (keyword == null) {
          // keyword가 null 또는 undefined인 경우
          keywordList.push("");
        } else if (keywordList.length > 0 && keywordList[keywordList.length - 1] === "") {
          // 마지막이 빈 문자열이면 갈아끼움
          keywordList[keywordList.length - 1] = keyword;
        } else {
          // 새로 추가
          keywordList.push(keyword);
        }
      
        return { keywordList };
      }, this.notifyParent);
    };
  
    handleRemoveKeyword = (idx) => {
      this.setState(prev => {
        const newList = [...prev.keywordList];
        newList.splice(idx, 1);
        return { keywordList: newList };
      }, this.notifyParent);
    };
  
    notifyParent = () => {
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(this.state.keywordList);
      }
    }
  
    render() {
      return (
        <div className="list_self_select_title_keword_area productKeywordInputList">
          {
                this.state.org_keyword_list.length > 0
                && 
                <div style={{fontSize:"14px", marginBottom:"8px"}}>
                  ※ 아래 키워드는 원본 알고리즘에 등록된 키워드입니다.
                  <br/>클릭 시 자동 등록됩니다.
                </div>
          }
          <div className="flexBox org_keyword_list">
            {
                this.state.org_keyword_list.length > 0
                ? 
                    this.state.org_keyword_list.map((obj, idx) => (
                        <Button
                            type={"hover_mint"}
                            width={"76px"}
                            height={"24px"}
                            fontSize={"14px"}
                            onClick={() => {
                                this.handleAddKeyword(obj)
                            }}
                        >
                            {"#"+obj}
                            <img src={default_plus_img} style={{width:"12px", height:"12px", marginLeft:"1px", marginBottom:"1px"}} />
                        </Button>
                    ))
                :   ""
            }
          </div>
          {this.state.keywordList.map((keyword, idx) => (
            <div className="list_self_select_title_keword" key={idx}>
              <TextInput
                width={350}
                height={38}
                value={keyword}
                placeholder={this.props.palceholder||"상품명의 단어를 입력해 주세요."}
                onChange={e => this.handleChangeKeyword(e, idx)}
              />
              <img src={default_plus_img} onClick={e => this.handleAddKeyword()} style={{ cursor: 'pointer' }} />
              {idx === 0
                ? <div className="empty_area"></div>
                : <img src={default_minus_img} onClick={() => this.handleRemoveKeyword(idx)} style={{ cursor: 'pointer' }} />
              }
            </div>
          ))}
        </div>
      );
    }
  }
